export default "__VITE_ASSET__DGw5qI4K__"